import React, { forwardRef } from 'react';
interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  label,
  error,
  helperText,
  className = '',
  id,
  ...props
}, ref) => {
  const textareaId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-346">
        {label && <label htmlFor={textareaId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-347">
            {label}
          </label>}
        <textarea ref={ref} id={textareaId} className={`
          block w-full rounded-lg border transition-colors duration-150
          focus:outline-none focus:ring-2 focus:ring-offset-0
          disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed
          resize-none
          ${error ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 text-gray-900 placeholder-gray-400 focus:ring-blue-500 focus:border-blue-500'}
          px-3 py-2.5 text-sm
          ${className}
        `} {...props} data-id="element-348" />
        {error && <p className="mt-1.5 text-sm text-red-600" data-id="element-349">{error}</p>}
        {helperText && !error && <p className="mt-1.5 text-sm text-gray-500" data-id="element-350">{helperText}</p>}
      </div>;
});
Textarea.displayName = 'Textarea';